import { cB as t } from "./ghl-ui.es384.js";
import { fadeInHeightExpandTransition as o } from "./ghl-ui.es1315.js";
const n = t("collapse-transition", {
  width: "100%"
}, [o()]);
export {
  n as default
};
